import { useCreateEvent } from "@/features/events/hooks/useCreateEvent";
import { EventType } from "@/features/events/types/EventType";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { PdfCard, PdfType } from "../../../pages/new-platform/components/PdfCard";
import { Exam } from "../../../utils/api-objects/Exam";
import { getAllExamsByType } from "../../../utils/apis/emr-service";
import { BucketFolder } from "../../../utils/enums/BucketFolder";
import { useAuthStore } from "../../../utils/stores/useAuthStore";
import { LoadingOverlay } from "../../shared/components/Loaders";

const UploadedForYou = () => {
    const { sendEvent } = useCreateEvent()
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId
    const navigate = useNavigate()

    const [isLoading, setIsLoading] = useState(true)
    const [reports, setReports] = useState<Exam[]>()

    useEffect(() => {
        if (!userId || !idToken) return
        getAllExamsByType(
            userId,
            idToken,
            BucketFolder.UploadedFromExpert,
            (exams) => {
                setReports(exams)
                setIsLoading(false)
            },
            (error) => {
                console.error(error)
                setIsLoading(false)
            }
        );

        void sendEvent({
            event: EventType.PAGE_VIEW,
            sub_category: "files_uploaded_from_expert_page",
        })
    }, []);

    // ********************************************************************************

    return (
        <div className="w-full h-full flex flex-col space-y-[20px]">
            {/* <div className="mt-[10px] space-y-[10px]">
                <BackButton
                    text="Torna a Test e referti"
                    onClick={() => navigate("/diagnostica/tests-and-reports")}
                />
                <div className="font-bold text-[25px] leading-[33px]">
                    Caricati per te
                </div>
            </div> */}
            <div className="font-normal text-[16px] leading-[26px]">
                In questa cartella puoi accedere a tutti i documenti che la tua Medical Equipe ha condiviso con te.
            </div>
            {
                reports && reports.map((report, index) => (
                    <PdfCard key={index} exam={report} pdfType={PdfType.Uploads} />
                ))
            }
            {isLoading && <LoadingOverlay />}
        </div>
    )
}

export default UploadedForYou
